import React from 'react';

import './style.scss';
import { upperCaseWordSplitAndSpace } from '../../../utils/regex.utils';

const ExperienceEditorComponentPlaceholder = ({ componentName = '', image = '' }) => {
  const formattedName = upperCaseWordSplitAndSpace(componentName);

  if (image) {
    return <img className="ExperienceEditorComponentPlaceholder__image" src={image} alt={formattedName} loading="lazy" />;
  }
  return <div className="ExperienceEditorComponentPlaceholder__text">{formattedName} - Component Placeholder</div>;
};

export default ExperienceEditorComponentPlaceholder;
